import $http from '@Config/axios';

const prefix = 'log-agenda-produto';

export default {
  index(params) {
    return new Promise((resolve, reject) => {
      $http.post(`${prefix}/index`, params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
